import { useCallback, useSyncExternalStore } from "react";
import { useAuth } from "@/context/AuthContext";
import { CLIENT_GROUPS } from "@/lib/clientes";

const CHANGE_EVENT = "netzer-client-list-preferences";
const memory = new Map();
const temporaryKeys = new Set();

function subscribe(callback) {
  window.addEventListener("storage", callback);
  window.addEventListener(CHANGE_EVENT, callback);
  return () => {
    window.removeEventListener("storage", callback);
    window.removeEventListener(CHANGE_EVENT, callback);
  };
}

function read(key) {
  if (temporaryKeys.has(key)) return memory.get(key) || null;
  try { return window.localStorage.getItem(key); }
  catch { return memory.get(key) || null; }
}

export function useClientListPreferences() {
  const { user } = useAuth();
  const key = `netzer:clientes:preferencias:${user?.id || "local"}`;
  const getSnapshot = useCallback(() => read(key), [key]);
  const snapshot = useSyncExternalStore(subscribe, getSnapshot, () => null);
  let saved;
  try { saved = JSON.parse(snapshot); } catch { saved = null; }
  const visualizacao = ["cards", "lista"].includes(saved?.visualizacao) ? saved.visualizacao : "lista";
  const grupo = CLIENT_GROUPS.some((item) => item.key === saved?.grupo) ? saved.grupo : "recorrentes";

  const update = (changes) => {
    const value = JSON.stringify({ visualizacao, grupo, ...changes });
    memory.set(key, value);
    try {
      window.localStorage.setItem(key, value);
      temporaryKeys.delete(key);
    } catch { temporaryKeys.add(key); }
    window.dispatchEvent(new Event(CHANGE_EVENT));
  };

  return { visualizacao, grupo, setVisualizacao: (value) => update({ visualizacao: value }), setGrupo: (value) => update({ grupo: value }) };
}
